module.exports = __webpack_public_path__ + "img/if_3.529ca9bf.png";